export default {
  settings: {
    title: "Ajustes",
    subtitle: "Gestiona tu cuenta y preferencias",
    nav: {
      profile: "Mi Perfil y Pareja",
      wedding: "Detalles de la Boda",
      event: "Detalles del Evento",
      collaborators: "Colaboradores",
      notifications: "Notificaciones",
      appearance: "Apariencia y Idioma",
      subscription: "Suscripción",
      security: "Seguridad"
    },
    groups: {
      account: "Cuenta",
      event: "Evento",
      preferences: "Preferencias"
    },
    general: {
      title: "Mi Perfil y Pareja",
      description: "Gestiona tu información personal y la de tu pareja.",
      me: "Yo",
      partner: "Mi Pareja",
      partnerHelp: "Invita a tu pareja a unirse a la gestión de la boda."
    },
    wedding: {
      title: "Detalles de la Boda",
      description: "Información esencial sobre tu evento."
    },
    appearance: {
      title: "Apariencia e Idioma",
      description: "Personaliza tu experiencia.",
      languages: {
        fr: "Francés",
        en: "Inglés",
        es: "Español",
        de: "Alemán",
        it: "Italiano"
      }
    },
    notifications: {
      email: {
        title: "Notificaciones por correo",
        description: "Recibe actualizaciones importantes y recordatorios por correo"
      },
      push: {
        title: "Notificaciones push",
        description: "Recibe alertas en tiempo real en tu navegador"
      },
      title: "Notificaciones",
      description: "Elige cómo y cuándo quieres recibir notificaciones.",
      enable: "Activar notificaciones",
      enableDesc: "Recibe alertas para eventos importantes",
      types: "Tipos de notificaciones",
      reminderTiming: "Tiempo de recordatorio predeterminado",
      hoursBefore: "{{count}}h antes",
      quietHours: "Horas de silencio",
      start: "Inicio",
      end: "Fin",
      labels: {
        tasks: "Tareas",
        guests: "Invitados",
        budget: "Presupuesto",
        system: "Sistema"
      },
      error: "Error al cargar la configuración de notificaciones"
    },
    security: {
      title: "Seguridad",
      description: "Gestiona tu contraseña y sesiones.",
      status: "Estado de la cuenta",
      verified: "Tu correo está verificado.",
      unverified: "Tu correo no está verificado.",
      sessions: "Sesiones activas",
      dangerZone: "Zona de peligro",
      deleteAccount: "Eliminar cuenta",
      deleteAccountHelp: "Esta acción es irreversible."
    },
    collaborators: {
      title: "Gestión de uso compartido",
      invitationsTitle: "Invitaciones de uso compartido",
      noWedding: "No se encontró ninguna boda",
      loadError: "Ocurrió un error al cargar la boda",
      invitationsError: "Ocurrió un error al cargar las invitaciones",
      noInvitations: "No se encontraron invitaciones",
      noInvitationsDesc: "Las invitaciones de uso compartido aparecerán aquí una vez creadas",
      expiresAt: "Expira el: {{date}}",
      accessCode: "Código de acceso: {{code}}",
      infoMessage: "Esta página muestra las invitaciones de uso compartido enviadas. Para crear nuevas invitaciones o gestionar colaboradores, utilice el componente ShareManagement en la configuración de su evento.",
      status: {
        pending: "Pendiente",
        accepted: "Aceptada",
        declined: "Rechazada",
        expired: "Expirada"
      },
      resourceTypes: {
        tasks: "Tareas",
        guests: "Invitados",
        budget: "Presupuesto",
        timeline: "Cronograma",
        tasksAndGuests: "Tareas e Invitados"
      }
    },
    subscription: {
      title: "Suscripción y Facturación",
      description: "Gestiona tu plan y sigue tu uso.",
      invoices: "Facturas",
      noInvoices: "No hay facturas disponibles",
      upgrade: "Pasar a Premium",
      features: {
        oneEvent: "1 Evento",
        basicGuests: "Lista de invitados básica",
        limitedTasks: "Tareas limitadas",
        unlimitedEvents: "Eventos ilimitados",
        unlimitedGuests: "Invitados ilimitados",
        export: "Exportar PDF y Excel",
        seating: "Plan de asientos avanzado",
        budget: "Presupuesto y Análisis",
        support: "Soporte prioritario"
      },
      proDescription: "Disfruta de todas las funciones sin límites.",
      freeDescription: "Pasa a Premium para desbloquear todas las funciones."
    },
    theme: "Tema",
    placeholders: {
      exampleName: "Ej: María García",
      exampleVenue: "Ej: Gran Hotel"
    },
    language: "Idioma",
    languageDescription: "Elige el idioma de la interfaz",
    account: {
      export: {
        button: "Exportar mis datos",
        loading: "Exportando..."
      },
      errors: {
        exportData: "Error al exportar datos",
        deleteAccount: "Error al eliminar cuenta"
      }
    },
    export: {
      title: "Exportar mis datos",
      description: "Descarga una copia de todos tus datos (invitados, tareas, presupuesto, etc.)",
      gdprNotice: "De acuerdo con el RGPD, puedes recuperar todos tus datos personales."
    },
    delete: {
      title: "Eliminar mi cuenta",
      description: "Esta acción es irreversible. Todos tus datos serán eliminados permanentemente.",
      confirmTitle: "¿Eliminar mi cuenta?",
      confirmDescription: "¿Estás seguro de que quieres eliminar permanentemente tu cuenta? Todos tus datos se perderán.",
      confirmButton: "Eliminar permanentemente"
    },
    firstName: "Nombre",
    lastName: "Apellidos",
    email: "Correo electrónico",
    partnerName: "Nombre completo",
    partnerEmail: "Correo electrónico (para invitación)",
    weddingDate: "Fecha de la boda",
    location: "Lugar y Ubicación",
    venue: "Lugar de recepción",
    country: "País",
    city: "Ciudad",
    guestCount: "Número estimado de invitados",
    password: "Contraseña",
    passwordHelp: "Último cambio hace 3 meses",
    changePassword: "Cambiar",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña"
  }
};